import React from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/styles/index.styl';

import Portfolio from '../src/scripts/containers/portfolio';
import utils from '../src/scripts/utils/utils';
import { Router } from '../src/scripts/routes';
import PageSpinner from '../src/scripts/components/PageSpinner';

class PortfolioPage extends React.Component {
  static async getInitialProps({ req, store, isServer, query }) {
    const { operatorId } = query;
    return { operatorId };
  }

  componentDidMount() {
    document.documentElement.classList.remove('preload');
  }

  render() {
    const { operatorId } = this.props;
    return (
      <>
        <Portfolio operatorId={operatorId} iframe={true} isSalsa={true} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const event = state.activeEvent;
  return {
    pageType: 'portfolio',
  };
};

export default connect(mapStateToProps)(PortfolioPage);
